import Vue from 'vue'
import Vuex from 'vuex'
import appConfigStoreModule from '@/core/app-config/appConfigStoreModule'
import auth from './auth'
import app from './app'
import promotion from './modules/promotion/index'
import giftRule from './modules/gift-rule/index'
import message from './message'
import applicationDescription from './modules/application-description/index'
import dictionary from './modules/dictionary/index'
import user from './modules/user/index'
import contact from './modules/contact/index'
import vacancy from './modules/vacancy/index'
import feedback from './modules/feedback/index'
import city from './modules/city/index'
import groupCriteria from './modules/group-criteria/index'
import notificationCampaign from './modules/notification-campaign/index'
import street from './modules/street/index'
import paymentMethod from './modules/payment-method/index'
import deliveryArea from './modules/delivery-area/index'
import crmSetting from './modules/crm-setting/index'
import orderType from './modules/order-type/index'
import role from './modules/role/index'
import customer from './modules/customer/index'
import restaurant from './modules/restaurant/index'
import order from './modules/order/index'
import menuVersion from './modules/menu-version/index'
import menuCategory from './modules/menu-category/index'
import dish from './modules/dish/index'
import counterParty from './modules/counter-party/index'
import crmClientSettings from './modules/crm-client-settings/index'
import qrCodeSettings from './modules/qr-code-settings/index'
import menuSyncSettings from './modules/menu-sync-settings/index'
import vacancyApplication from './modules/vacancy-application/index'
import reportStatistics from './modules/report/statistics/index'
import dashboard from './modules/report/dashboard/index'
import referralCodeSettings from './modules/referral-code-settings/index'
import digitalCurrency from './modules/report/digiral-currency/index'
import digitalCurrencyByBranch from './modules/report/digital-currency-by-branch/index'
import operatorReport from './modules/report/operator/index'
import paymentReconciliation from './modules/report/payment-reconciliation/index'
import loyaltyProgramSettings from './modules/loyalty-program-settings/index'
import customerLoyalty from './modules/customer-loyalty/index'
import orderState from './modules/order-state/index'
import orderWorkflow from '@/store/modules/order-workflow/index'
import dishTranslations from '@/store/modules/dish-translation/index'
import modifierGroupTranslations from '@/store/modules/modifier-group-translation/index'
import modifierGroupDetailsTranslations from '@/store/modules/modifier-group-detail-translation/index'
import modifierSchemeTranslations from '@/store/modules/modifier-scheme-translation/index'
import orderCancellationSettings from '@/store/modules/order-cancellation-settings/index'
import maintenanceSettings from '@/store/modules/maintenance-settings/index'
import paymentSettings from '@/store/modules/payment-settings/index'
import serviceDish from '@/store/modules/service-dish/index'
import applianceRule from '@/store/modules/appliance-rule/index'
import orderPaymentLog from '@/store/modules/order-payment-log/index'
import orderDeliveryLog from '@/store/modules/order-delivery-log/index'
import orderBakaiLog from '@/store/modules/order-bakai-log/index'
import orderIntegrationLog from '@/store/modules/order-integration-log/index'
import orderStatusHistory from '@/store/modules/order-status-history/index'
import courier from '@/store/modules/courier/index'
import deliveryLogSettings from '@/store/modules/delivery-log-settings/index'
import bakaiLogSettings from '@/store/modules/bakai-log-settings/index'
import cartCalculationSettings from '@/store/modules/cart-calculation-settings/index'
import exchangeLogSettings from '@/store/modules/exchange-log-settings/index'
import paymentCallbacks from '@/store/modules/payment-callbacks/index'
import integrationExchange from '@/store/modules/integration-exchange/index'
import notificationSettings from '@/store/modules/notification-settings/index'
import smsJournal from '@/store/modules/sms-journal/index'
import workflow from '@/store/modules/workflow/index'
import webhook from '@/store/modules/webhook/index'
import exchangeStorage from '@/store/modules/exchange-storage/index'

Vue.use(Vuex)

const storeModules = {
  auth,
  vacancy,
  menuCategory,
  notificationCampaign,
  orderCancellationSettings,
  maintenanceSettings,
  paymentSettings,
  message,
  promotion,
  giftRule,
  applicationDescription,
  dictionary,
  serviceDish,
  applianceRule,
  menuVersion,
  modifierGroupDetailsTranslations,
  modifierGroupTranslations,
  modifierSchemeTranslations,
  orderWorkflow,
  orderPaymentLog,
  orderDeliveryLog,
  deliveryLogSettings,
  orderBakaiLog,
  orderIntegrationLog,
  orderStatusHistory,
  courier,
  integrationExchange,
  notificationSettings,
  smsJournal,
  workflow,
  webhook,
  exchangeStorage,
  bakaiLogSettings,
  cartCalculationSettings,
  exchangeLogSettings,
  paymentCallbacks,
  reportStatistics,
  dashboard,
  orderState,
  user,
  digitalCurrencyByBranch,
  operatorReport,
  paymentReconciliation,
  loyaltyProgramSettings,
  customerLoyalty,
  restaurant,
  qrCodeSettings,
  menuSyncSettings,
  paymentMethod,
  referralCodeSettings,
  order,
  street,
  crmClientSettings,
  dish,
  app,
  digitalCurrency,
  customer,
  dishTranslations,
  vacancyApplication,
  deliveryArea,
  city,
  groupCriteria,
  feedback,
  counterParty,
  contact,
  orderType,
  role,
  crmSetting,
  appConfig: appConfigStoreModule,
}

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: storeModules,
})

const recursivelyProcessWatchers = module => {
  if (module.watchers) {
    module.watchers.forEach(params => {
      store.watch(...params)
    })
  }
  if (!module.modules) {
    return
  }
  for (const subModule of Object.keys(module.modules)) {
    recursivelyProcessWatchers(module.modules[subModule])
  }
}

Object.keys(storeModules).forEach(moduleName => {
  recursivelyProcessWatchers(storeModules[moduleName])
})

export default store
